module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_2_2.c28b06ed.png";